import { createFileRoute, redirect } from '@tanstack/react-router'
import { PermissionsPage } from '@/pages/permissions/PermissionsPage'
import { getRoutePermissionRule } from '@/constants/route-permissions'
import { getDefaultStore } from 'jotai'
import { permissionsAtom } from '@/store/auth.atom'

export const Route = createFileRoute('/_private/permissions/')({
  beforeLoad: async () => {
    const pathname = '/permissions'
    const rule = getRoutePermissionRule(pathname)
    if (!rule) return null

    const permissions = getDefaultStore().get(permissionsAtom)
    const allowed =
      rule.kind === 'single'
        ? permissions.includes(rule.permission)
        : rule.permissions.some((p) => permissions.includes(p))

    if (!allowed) {
      throw redirect({ to: '/dashboards' })
    }

    return null
  },
  component: PermissionsPage,
})
